import { TabItem, Tabs } from '@acme/foundation';
import { createTheme } from 'flowbite-react';
import { ApplicationComments } from '../../../features/applicationComments';
import { ApplicationHistory } from '../../../features/applicationHistory';

export const ApplicationActivity = () => {
  const tabItems: TabItem[] = [
    {
      key: 'comments',
      title: 'Комментарии',
      content: <ApplicationComments />,
    },
    {
      key: 'history',
      title: 'История',
      content: <ApplicationHistory />,
    },
  ];

  const tabsTheme = createTheme({
    tabs: {
      base: 'flex flex-col bg-white p-4 rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]',
      tablist: {
        base: 'flex gap-4 items-center pb-4',
        tabitem: {
          base: 'flex items-center justify-center px-4 py-2 p-0 rounded-lg text-sm font-normal leading-[1.5] first:ml-0 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500',
          variant: {
            default: {
              base: 'px-4 py-2',
              active: {
                on: 'bg-brand-purple-900 text-white',
                off: 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
              },
            },
          },
        },
      },
      tabpanel: '',
    },
  }).tabs;

  return <Tabs items={tabItems} defaultActiveKey="history" theme={tabsTheme} />;
};
